import React from "react";

// Reusable page hero component
const PageHero = ({ eyebrow, headline, intro, illustration, hideDivider = false }) => {
  return (
    <section className="bg-[#fbf7ee]">
      <div className={`max-w-[1400px] mx-auto px-6 md:px-10 lg:px-14 pt-16 md:pt-20 lg:pt-24 ${intro ? (illustration ? "pb-6 md:pb-8 lg:pb-10" : "pb-16 md:pb-20 lg:pb-24") : "pb-4 md:pb-6"}`}>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 items-center">
          <div className={`${illustration ? "lg:col-span-7" : "lg:col-span-12"} text-center`}>
            {eyebrow && (
              <div className="font-sans-nav text-[12px] tracking-[0.32em] uppercase text-[#c9a961] mb-5 animate-rise">
                {eyebrow}
              </div>
            )}
            <h1 className="font-display text-[#1e2952] text-[40px] sm:text-[48px] md:text-[56px] lg:text-[62px] leading-[1.06] tracking-tight animate-rise delay-1" style={{ fontWeight: 500 }}>
              {headline}
            </h1>
            <div className={`${hideDivider ? "hidden" : "mt-7 flex items-center gap-4 justify-center"} animate-rise delay-2`}>
              <span className="block h-px w-40 bg-[#c9a961]"></span>
              <span className="text-[#c9a961]">†</span>
              <span className="block h-px w-40 bg-[#c9a961]"></span>
            </div>
            {intro && (
              <p className="font-serif-body mt-7 text-[#3a466e] text-[17px] md:text-[18px] leading-[1.75] max-w-[640px] mx-auto animate-rise delay-3">
                {intro}
              </p>
            )}
          </div>
          {illustration && (
            <div className="lg:col-span-5 flex justify-center animate-rise delay-2">
              {illustration}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export const SectionHeading = ({ eyebrow, title, className = "", hideDivider = false }) => (
  <div className={`text-center mb-12 ${className}`}>
    {eyebrow && (
      <div className="font-sans-nav text-[11.5px] tracking-[0.32em] uppercase text-[#c9a961] mb-4">
        {eyebrow}
      </div>
    )}
    <h2 className="font-display text-[#1e2952] text-[32px] md:text-[40px] lg:text-[44px] leading-tight" style={{ fontWeight: 500 }}>
      {title}
    </h2>
    {!hideDivider && (
      <div className="mt-5 flex items-center justify-center gap-3">
        <span className="block h-px w-40 bg-[#c9a961]"></span>
        <span className="text-[#c9a961] text-sm">†</span>
        <span className="block h-px w-40 bg-[#c9a961]"></span>
      </div>
    )}
  </div>
);

export const OrnamentDivider = () => (
  <div className="flex items-center justify-center gap-3 my-10">
    <span className="block h-px w-40 bg-[#c9a961]"></span>
    <span className="text-[#c9a961]">†</span>
    <span className="block h-px w-40 bg-[#c9a961]"></span>
  </div>
);

export default PageHero;
